const DataLocation = {
  locationIcon: [
    {
      icon: "fas fa-envelope",
      title: " Our Mail",
      worktime: "coffee_heaven@gmail.com",
    },
    {
      icon: "fas fa-clock",
      title: " Opening Hours",
      worktime: " 07.00AM To 11.00PM",
    },
    {
      icon: "fas fa-map-marker-alt",
      title: " Shop Location",
      worktime: "63ST New-Cairo , Egypt",
    },
    {
      icon: "fas fa-phone-alt",
      title: " Our Number",
      worktime: "00201125360114",
    },
  ],
};

export default DataLocation;
